import { useEffect, useState } from "react";
import api, { extractErr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { UserRound, Phone, MessageSquare } from "lucide-react";

export default function SuperLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/platform/leads")
      .then(({ data }) => setLeads(data))
      .catch((e) => toast.error(extractErr(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h1 className="font-display text-3xl font-bold">Chatbot leads</h1>
        <p className="text-slate-500 text-sm mt-1">Visitors who shared their name & WhatsApp number with Mira on the landing page.</p>
      </div>

      {loading ? (
        <p className="text-slate-500 text-sm">Loading…</p>
      ) : leads.length === 0 ? (
        <Card className="bg-slate-900 border-slate-800 p-8 text-center">
          <MessageSquare className="w-8 h-8 text-slate-600 mx-auto" />
          <p className="text-slate-400 mt-3">No leads captured yet.</p>
        </Card>
      ) : (
        <div className="space-y-3">
          {leads.map((l) => (
            <Card key={l.session_id} data-testid={`lead-row`} className="bg-slate-900 border-slate-800 p-4 flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-indigo-500/20 border border-indigo-400/40 flex items-center justify-center flex-shrink-0">
                <UserRound className="w-5 h-5 text-indigo-300" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-white">{l.name || "Unknown"}</div>
                <a href={`https://wa.me/91${l.phone}`} target="_blank" rel="noreferrer" className="text-sm text-emerald-300 hover:text-emerald-200 inline-flex items-center gap-1.5">
                  <Phone className="w-3.5 h-3.5" /> +91 {l.phone}
                </a>
              </div>
              <div className="text-xs text-slate-500 text-right">
                {l.created_at ? new Date(l.created_at).toLocaleString() : ""}
                <div className="text-slate-600">{l.source}</div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
